import {
  FC,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Swiper } from 'swiper/types';
import classNames from 'classnames';
import swiperCss from '@edikk-edikk/country-common/css/modules/swiper.module.scss';
import advertDetailCss from '../../assets/advert-detail.module.scss';
import galleryCss from '../../assets/gallery/gallery.module.scss';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import { GalleryHeader, GalleryItem, Thumbnails } from '#advertDetail/components';

const Gallery: FC = () => {
  const {
    advert: {
      photos,
    },
  } = useAdvertDetailContext();
  const [activePhotoIndex, setActivePhotoIndex] = useState<number>(0);

  const refMainSwiper = useRef<HTMLDivElement>(null);
  const refMainInstance = useRef<Swiper>(null);

  useEffect(() => {
    import('swiper').then(({ Swiper: SwiperInstance }) => {
      if (!refMainSwiper.current) {
        return;
      }

      refMainInstance.current = new SwiperInstance(refMainSwiper.current, {
        slidesPerView: 1,
        wrapperClass: swiperCss.swiper__wrapper,
        slideClass: swiperCss.swiper__slide,
        loop: photos.length > 1,
        on: {
          slideChange: (swiper: Swiper) => {
            setActivePhotoIndex(swiper.realIndex);
          },
        },
      });
    });
  }, [photos.length]);

  if (photos.length === 0) {
    return null;
  }

  const renderMainSlide = () => photos.map((photo, index) => (
    <GalleryItem key={photo.id} photo={photo} index={index} />
  ));

  const renderThumbnails = (): ReactNode => {
    if (photos.length < 2) {
      return null;
    }

    return <Thumbnails refMainInstance={refMainInstance} activePhotoIndex={activePhotoIndex} />;
  };

  return (
    <div className={classNames(advertDetailCss.advertDetail__gallery, galleryCss.gallery)}>
      <GalleryHeader />
      <div ref={refMainSwiper}>
        <div className={swiperCss.swiper__wrapper}>
          {renderMainSlide()}
        </div>
      </div>
      {renderThumbnails()}
    </div>
  );
};

export { Gallery };
